import React, { Component } from "react";
import { connect } from 'react-redux';
import { Auth } from "aws-amplify";
import { FormGroup, FormControl, ControlLabel, Modal } from "react-bootstrap";
import LoaderButton from "../../../components/LoaderButton";

const mapStateToProps = (state) => {
 return {
   showLoginPanel: state.root.showLoginPanel,
   isAuthenticated: state.session.isAuthenticated,
   user: state.session.user
 }
}

const mapDispatchToProps = (dispatch) => {
   return {
     toggleLoginPanel: () => {
         console.log('dispatching login panel hide');
         dispatch({type: 'HIDE_LOGIN_PANEL'});
     },
     userHasAuthenticated: (user) => {
       console.log('authenticating...', user);
       dispatch({type: 'LOGIN_USER_SUCCESS', user});
     }
   }
}

class Login extends Component {
  constructor(props) {
    super(props);
    this.props = props;

    //this.handleShow = this.handleShow.bind(this);

    // creates a state object where we will store our user connecting it to email + pass
    // this means that when the state changes, react will re-render these components with new val
    this.state = {
      isLoading: false,
      email: "",
      password: ""
    };

  }

  //checks fields are not empty
  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  // updates the state on user input with id (set as controlId for the <FormGroup>) of the field being changed
  // to have access THIS keyword we store the ref to an anonymous function: handleChange = (event) => { } .
  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = async event => {
    event.preventDefault();

    this.setState({ isLoading: true })

    try {
      //await promise from Auth.signin
      await Auth.signIn(this.state.email, this.state.password);
      await Auth.currentUserInfo().then(result => {
        console.log('in here', result);
        this.setState({ isLoading: false });
        this.props.userHasAuthenticated(result);
        this.props.toggleLoginPanel();
        //this.props.user = result;
      });

    } catch(e) {
      alert(e.message);
      this.setState({ isLoading: false });
    }
  }

  render() {
    return (
      <div className="Login">
        <form onSubmit={this.handleSubmit}>
          <FormGroup controlId="email" bsSize="large">
            <span className="fas fa-user min-width-3 text-center mr-2" />
            <FormControl
              autoFocus
              type="email"
              placeholder="Email"
              value={this.state.email}
              onChange={this.handleChange}
            />
          </FormGroup>
          <FormGroup controlId="password" bsSize="large">
            <span className="fas fa-lock" />
            <FormControl
              value={this.state.password}
              onChange={this.handleChange}
              type="password"
              placeholder="password"
            />
          </FormGroup>
          <div className="forgotten-password">
            <a href="#">Forgotten password?</a>
          </div>
          <LoaderButton
            block
            bsSize="large"
            disabled={!this.validateForm()}
            type="submit"
            isLoading={this.state.isLoading}
            text="Login"
            loadingText="Logging in…"
          />
        </form>
      </div>

    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/auth/views/Login.js